import { Typography, TypographyProps } from '@mui/material'

interface ChampBlocPhotoProps extends TypographyProps {
  noDefaultSx?: boolean
}

export default function ChampBlocPhoto({ children, sx, noDefaultSx, ...rest }: Readonly<ChampBlocPhotoProps>) {
  return (
    <Typography
      component="p"
      variant="subtitle2"
      color="textSecondary"
      sx={noDefaultSx ? sx : { marginBottom: '0.5em', ...sx }}
      tabIndex={0}
      {...rest}
    >
      {children}
    </Typography>
  )
}
